import React from "react";
import { useNavigate } from "react-router-dom";
import './Styles.css';

const EmailVerified = () => {
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate("/subscription-setup");
  };

  return (
    <div className="app-container">
      <h1>Email Verified</h1>
      <p>Your email has been successfully verified.</p>
      <button onClick={handleContinue}>Continue to Subscription Setup</button>
    </div>
  );
};

export default EmailVerified;
